export default "__VITE_ASSET__CQWzz230__"